import {
  lang
} from '../utils/lang.js'

export const startTimeOptions = [{
  label: '0.2s',
  value: 200
}, {
  label: '0.4s',
  value: 400
}, {
  label: '0.6s',
  value: 600
}, {
  label: '0.8s',
  value: 800
}, {
  label: '1s',
  value: 1000
}]

export const cutGapOptions = [{
  label: '0.1s',
  value: 100
}, {
  label: '0.2s',
  value: 200
}, {
  label: '0.3s',
  value: 300
}, {
  label: '0.4s',
  value: 400
}, {
  label: '0.5s',
  value: 500
}]

export const qualityOptions = (language) => {
  return [{
    label: lang('qualityLow', language),
    value: 3
  }, {
    label: lang('qualityMid', language),
    value: 2
  }, {
    label: lang('qualityHigh', language),
    value: 1
  }]
}